import React, { useState } from "react";
import { Tab, Segment, Header } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListPost, PostForm } from "../../../components/Admin/Post";
import { ViewReports } from "../../../components/Admin/Reports/ViewReports/ViewReports";
import "./Reports.scss";
import { useLanguage } from "../../../contexts";

export function Reports() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListPost reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <Segment className="reports-page__title">
        <Header as="h1">{t("reports")}</Header>
      </Segment>
      <ViewReports />
    </>
  );
}
